<template>
  <div class="app-bar">
    <v-app-bar
      app
      color="#880E4F"
      dark
    >
      <v-btn
        v-if="showBackButton"
        icon
        @click="goBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        v-if="!showBackButton"
        @click="$emit('hamb-click')"
      />

      <v-toolbar-title class="headline text-uppercase">
        <span @click="$router.push('/')">{{ appName }}</span>
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items v-if="!isOnline">
        <v-btn text>
          Hors ligne
        </v-btn>
      </v-toolbar-items>

      <v-btn
        v-if="isLoggedIn"
        text
        @click="$emit('logout')"
      >
        Déconnexion
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "AppBar",
  computed: {
    ...mapState({
      showBackButton: state => state.showBackButton

      // isOnline: state => state.isOnline
    }),

    ...mapGetters({ isLoggedIn: "auth/isLoggedIn" }),

    // Show back button if we are on a router match who reclaim it (meta => goback == true)
    showBackButton() {
      return this.$route.matched.reduce((acc, x) => {
        return x.meta.goback !== undefined ? x.meta.goback : acc;
      }, false);
    },

    appName() {
      switch (process.env.VUE_APP_ENV) {
        case "dev":
          return "Alan Dev";
        case "preprod":
          return "Alan Preprod";
        default:
          return "Alan";
      }
    },

    isDev() {
      return process.env.VUE_APP_ENV == "dev";
    }
  },
  methods: {
    goBack() {
      const goto = this.$route.matched.some(record => record.meta.goto);

      if (goto) {
        this.$router.push({ name: this.$route.meta.goto });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style></style>
